import Cookies from 'universal-cookie';

import { wave } from './config';

const cookies = new Cookies();

export default async function postRatings(body) {
  const authorization = cookies.get('token');
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await wave.post('/v2/ratings', body, { headers });

    const { rating } = response.data.payload;
    return { rating };
  } catch (error) {
    const userMessage = error.response?.data?.error?.userMessage || 'Κάτι πήγε στραβά. Παρακαλούμε προσπαθήστε ξανά.';
    return { rating: {}, error: userMessage };
  }
}
